import axios from 'axios'
import { AUTH_HEADERS } from '../utils/config'
export default {
  getAll (limit, offset) {
    return axios.get(`${process.env.VUE_APP_BASE_URL}changeOrder/all?limit=${limit}&offset=${offset}`, AUTH_HEADERS())
  },
  get (id) {
    return axios.get(`${process.env.VUE_APP_BASE_URL}changeOrder/${id}`, AUTH_HEADERS())
  },
  // There is also a Get By Status call in the conroller that can be added
  getByTask (id) {
    return axios.get(`${process.env.VUE_APP_BASE_URL}changeOrder/task/${id}`, AUTH_HEADERS())
  },
  create (changeOrder) {
    return axios.post(`${process.env.VUE_APP_BASE_URL}changeOrder/create`, changeOrder, AUTH_HEADERS())
  },
  update (changeOrder) {
    return axios.put(`${process.env.VUE_APP_BASE_URL}changeOrder/update`, changeOrder, AUTH_HEADERS())
  },
  delete (id) {
    return axios.delete(`${process.env.VUE_APP_BASE_URL}changeOrder/remove/${id}`, AUTH_HEADERS())
  }
}
